import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api, { track } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    whatsapp_number: "5511962029032",
    whatsapp_message: "Olá! Vim pelo site da ChessUp Academy e gostaria de saber mais sobre os cursos e a assinatura.",
    price_amount: 9990,
    price_currency: "brl",
    plan_name: "ChessUp Academy Premium",
  });

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (data && data.whatsapp_number) setSettings((s) => ({ ...s, ...data }));
    }).catch(() => {});
  }, []);

  const whatsappUrl = useCallback(() => {
    const num = settings.whatsapp_number || "5511962029032";
    const msg = encodeURIComponent(settings.whatsapp_message || "");
    return `https://wa.me/${num}?text=${msg}`;
  }, [settings.whatsapp_number, settings.whatsapp_message]);

  const openWhatsapp = useCallback((source) => {
    track("whatsapp_click", source);
    window.open(whatsappUrl(), "_blank", "noopener");
  }, [whatsappUrl]);

  const value = useMemo(
    () => ({ settings, whatsappUrl, openWhatsapp }),
    [settings, whatsappUrl, openWhatsapp]
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
